import { AgentFeature } from '../../../components/agent-features'
import { AgentLanguageEnum } from '../../../graphql/schema/queries/agent-features'
import { Connector } from '../../connector'

export async function getAgentFeatures(this: {
  readonly connector: Connector
}): Promise<AgentFeature[]> {
  const { features } = await this.connector.get(
    `/agent/feature?expand=skip_links`
  )

  return features.map(setLanguages)
}

function setLanguages({ name, languages }): AgentFeature {
  return {
    name,
    languages: languages.map((lang) => AgentLanguageEnum[lang])
  }
}
